import React, {Component} from 'react';
import './PageFooter.css';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';

// url to make chat popup on web
const CHAT_URL = window.cordova
	? '/'
	: process.env.NODE_ENV === 'development'
	? 'http://dev.b2me.com.au:3000/'
	: 'https://b2me.com.au/';

class PageFooter extends Component {
	render() {
		return (
			<footer
				className={`PageFooter ${
					this.props.location.pathname === '/stream' && this.props.screenSize === 'mobile'
						? 'TabsMargin'
						: ''
				}`}>
				<ul className="PageFooter-brands">
					<li>
						<a
							href="http://www.ecu.edu.au/"
							title="Edith Cowan University"
							target="_blank"
							rel="noopener noreferrer">
							<img src="/img/ecu.png" alt="ECU" />
						</a>
					</li>
					<li>
						<a
							href="https://www.communitynews.com.au/"
							title="Community News Group"
							target="_blank"
							rel="noopener noreferrer">
							<img src="/img/communitynews.png" alt="Community News Group" />
						</a>
					</li>
					<li>
						<a
							href="https://www.hhg.com.au/"
							title="HHG Legal Group"
							target="_blank"
							rel="noopener noreferrer">
							<img src="/img/HHGLogo.png" alt="HHG Legal Group" />
						</a>
					</li>
					<li>
						<a
							href="http://www.98five.com/"
							title="98five Sonshine FM"
							target="_blank"
							rel="noopener noreferrer">
							<img src="/img/sonshine.png" alt="98five Sonshine FM" />
						</a>
					</li>
				</ul>

				<ul className="PageFooter-mobilePromo">
					<li>
						<a
							href="https://apps.apple.com/au/app/b2me/id1497658323?mt=8"
							target="_blank"
							rel="noopener noreferrer"
							style={{
								display: 'inline-block',
								overflow: 'hidden',
								background:
									'url(https://linkmaker.itunes.apple.com/en-gb/badge-lrg.svg?releaseDate=2020-05-14&kind=iossoftware&bubble=ios_apps) no-repeat',
								width: '135px',
								height: '40px'
							}}
						/>
					</li>
					<li>
						<a
							href="https://play.google.com/store/apps/details?id=au.com.b2me&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
							target="_blank"
							rel="noopener noreferrer"
							style={{
								display: 'inline-block',
								overflow: 'hidden',
								width: '135px',
								height: '40px',
								marginLeft: '4px',
								background:
									'url(https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg) no-repeat'
							}}
						/>
					</li>
				</ul>

				{this.props.screenSize !== 'mobile' && (
					<React.Fragment>
						<section className="PageFooter-sitemap">
							<p>Support</p>
							<ul>
								<li>
									<a href="mailto:enquiries@b2me.com.au">Email us</a>
								</li>
								<li>
									<a href="tel:0432854880">Call us</a>
								</li>
								<li>
									<a href="https://b2me.zendesk.com" target="_blank" rel="noopener noreferrer">
										Support
									</a>
								</li>
								<li>
									<a
										href="https://b2me.zendesk.com/hc/en-us"
										target="_blank"
										rel="noopener noreferrer">
										Learning centre
									</a>
								</li>
							</ul>
						</section>
						<section className="PageFooter-sitemap">
							<p>Information</p>
							<ul>
								<li>
									<a
										href="https://b2me.zendesk.com/hc/en-us/categories/360000111713-About-B2Me"
										target="_blank"
										rel="noopener noreferrer">
										About us
									</a>
								</li>
								<li>
									<a
										href="https://b2me.zendesk.com/hc/en-us/articles/360003384294-Meet-our-Team"
										target="_blank"
										rel="nonopener noreferrer">
										Meet our people
									</a>
								</li>
								<li>
									<Link to="/news-press">News and press</Link>
								</li>
								<li>
									<Link to="/events">Upcoming events</Link>
								</li>
								<li>
									<a href="/privacy201809_2.pdf" target="_blank" rel="noopener noreferrer">
										Privacy policy
									</a>
								</li>
								<li>
									<a href="/terms201902_1.pdf" target="_blank" rel="noopener noreferrer">
										Terms of use
									</a>
								</li>
							</ul>
						</section>
						<section className="PageFooter-sitemap">
							<p>B2Me for you</p>
							<ul>
								<li>
									<a href={`${CHAT_URL}schools`}>B2Me for schools</a>
								</li>
								<li>
									<a href={`${CHAT_URL}sports`}>B2Me for sports</a>
								</li>
								<li>
									<a href={`${CHAT_URL}real-estate`}>B2Me for real estate</a>
								</li>
								<li>
									<Link to="/faith">B2Me for faith communities</Link>
								</li>
							</ul>
						</section>
						<section className="PageFooter-connections">
							<p>Social</p>
							<ul>
								<li>
									<a href="mailto:enquiries@b2me.com.au">
										<span className="icon icon-contact_mail" />
										enquiries@b2me.com.au
									</a>
								</li>
								<li>
									<a href="tel:0432854880">
										<span className="icon icon-phone" />
										0432854880
									</a>
								</li>
								<li>
									<a
										href="https://medium.com/b2me-australia"
										target="_blank"
										rel="noopener noreferrer">
										<span className="icon icon-web" />
										<span>Blog</span>
									</a>
								</li>
								<li>
									<a
										href="https://www.facebook.com/B2MeAustralia/"
										target="_blank"
										rel="noopener noreferrer">
										<span className="icon icon-facebook2" />
										<span>Facebook</span>
									</a>
								</li>
								<li>
									<a
										href="https://twitter.com/B2MeAustralia"
										target="_blank"
										rel="noopener noreferrer">
										<span className="icon icon-twitter" />
										<span>Twitter</span>
									</a>
								</li>
								<li>
									<a
										href="https://www.instagram.com/b2meaustralia/"
										target="_blank"
										rel="noopener noreferrer">
										<span className="icon icon-instagram" />
										<span>Instagram</span>
									</a>
								</li>
								<li>
									<a
										href="https://www.pinterest.com.au/b2meaustralia/boards/"
										target="_blank"
										rel="noopener noreferrer">
										<span className="icon icon-pinterest" />
										<span>Pinterest</span>
									</a>
								</li>
							</ul>
							<p>Copyright B2Me {new Date().getFullYear()}.</p>
						</section>
						<section className="PageFooter-tag">
							<img
								className="PageFooter-logo"
								src="/img/b2me-full-valueprop-inverse.svg"
								alt="B2Me logo"
							/>
						</section>
					</React.Fragment>
				)}
			</footer>
		);
	}
}

export default connect(
	state => ({screenSize: state.ui.screenSize}),
	{}
)(PageFooter);



// WEBPACK FOOTER //
// ./src/chrome/PageFooter.js